import {CritereEgalimEnum} from "../../enums/egalim/critere-egalim-enum";

export class SeuilEgalimDto {

  critere: CritereEgalimEnum;
  label: string;
  seuil: number;


  constructor(critere: CritereEgalimEnum, label: string, seuil: number) {
    this.critere = critere;
    this.label = label;
    this.seuil = seuil;
  }
}

/**
 * Lit un seuil par critère plutôt que par position : l'ordre d'affichage
 * de la jauge n'a pas à contraindre le calcul de conformité.
 */
export const findSeuilEgalim = (seuilList: SeuilEgalimDto[], critere: CritereEgalimEnum): number =>
  seuilList?.find(seuil => seuil.critere === critere)?.seuil;
